import React from 'react';

function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 -960 960 960">
      <path
        fill={props.fill || '#1D252D'}
        d="M320-603.846q15.077 0 25.615-10.539 10.539-10.538 10.539-25.615 0-15.077-10.539-25.615-10.538-10.539-25.615-10.539-15.077 0-25.615 10.539-10.539 10.538-10.539 25.615 0 15.077 10.539 25.615 10.538 10.539 25.615 10.539zm0 160q15.077 0 25.615-10.539 10.539-10.538 10.539-25.615 0-15.077-10.539-25.615-10.538-10.539-25.615-10.539-15.077 0-25.615 10.539-10.539 10.538-10.539 25.615 0 15.077 10.539 25.615 10.538 10.539 25.615 10.539zm0 160q15.077 0 25.615-10.539 10.539-10.538 10.539-25.615 0-15.077-10.539-25.615-10.538-10.539-25.615-10.539-15.077 0-25.615 10.539-10.539 10.538-10.539 25.615 0 15.077 10.539 25.615 10.538 10.539 25.615 10.539zM212.309-140.001q-30.308 0-51.308-21t-21-51.308v-535.382q0-30.308 21-51.308t51.308-21h419.229l188.461 188.461v419.229q0 30.308-21 51.308t-51.308 21H212.309zm0-59.999h535.382q5.385 0 8.847-3.462 3.462-3.462 3.462-8.847V-600H600v-160H212.309q-5.385 0-8.847 3.462-3.462 3.462-3.462 8.847v535.382q0 5.385 3.462 8.847 3.462 3.462 8.847 3.462zM200-760v160-160 560-560z"
      ></path>
    </svg>
  );
}

export default Icon;
